import React from 'react';
import EmailSettings from './EmailSettings';
import SmsSettings from './SmsSettings';
import LoadingSpinner from '../LoadingSpinner';

const SettingsTab = ({
  activeTab,
  emailSettings,
  setEmailSettings,
  smsSettings,
  setSmsSettings,
  handleSaveEmailSettings,
  handleSaveSmsSettings,
  loading,
  dataLoading
}) => {
  return (
    <div className="max-w-2xl mx-auto">
      {dataLoading.settings ? (
        <LoadingSpinner />
      ) : (
        <>
          {activeTab === 'email' ? (
            <EmailSettings
              emailSettings={emailSettings}
              setEmailSettings={setEmailSettings}
              handleSaveEmailSettings={handleSaveEmailSettings}
              loading={loading}
            />
          ) : (
            <SmsSettings
              smsSettings={smsSettings}
              setSmsSettings={setSmsSettings}
              handleSaveSmsSettings={handleSaveSmsSettings}
              loading={loading}
            />
          )}
        </>
      )}
    </div>
  );
};

export default SettingsTab;